import { render, staticRenderFns } from "./BlockedInvestmentModal.vue?vue&type=template&id=01b6cbf5&scoped=true"
import script from "./BlockedInvestmentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlockedInvestmentModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BlockedInvestmentModal.vue?vue&type=style&index=0&id=01b6cbf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6cbf5",
  null
  
)

export default component.exports